import { Components, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiSelect to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/select/#css
 */
export const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'medium',
  },
  styleOverrides: {
    // Prevent MUI's defaults from applying - we're establishing our own styles for the standard variant
    standard: {
      backgroundColor: 'transparent',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
};
